
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class GiftVoucherMasterDialog extends Serenity.EntityDialog<GiftVoucherMasterRow, any> {
        protected getFormKey() { return GiftVoucherMasterForm.formKey; }
        protected getIdProperty() { return GiftVoucherMasterRow.idProperty; }
        protected getLocalTextPrefix() { return GiftVoucherMasterRow.localTextPrefix; }
        protected getNameProperty() { return GiftVoucherMasterRow.nameProperty; }
        protected getService() { return GiftVoucherMasterService.baseUrl; }
        protected getDeletePermission() { return GiftVoucherMasterRow.deletePermission; }
        protected getInsertPermission() { return GiftVoucherMasterRow.insertPermission; }
        protected getUpdatePermission() { return GiftVoucherMasterRow.updatePermission; }

        protected form = new GiftVoucherMasterForm(this.idPrefix);

    }
}